import { render, staticRenderFns } from "./ItemAIImportInterface.vue?vue&type=template&id=351da70b"
import script from "./ItemAIImportInterface.vue?vue&type=script&lang=js"
export * from "./ItemAIImportInterface.vue?vue&type=script&lang=js"
import style0 from "./ItemAIImportInterface.vue?vue&type=style&index=0&id=351da70b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
